module.exports = __webpack_public_path__ + "static/media/poe.39cc01ba.svg";